// extracted by mini-css-extract-plugin
module.exports = {"imgfaq":"Section_FAQ_imgfaq__1S1Pt","containerfaq":"Section_FAQ_containerfaq__gH3kJ","columnFAQ":"Section_FAQ_columnFAQ__2WrpW"};